import React, { useState } from "react";
import InnerHaeder from "../Component/InnerHaeder";
import Highlights from "../Component/Highlights";
import Footer from "../Component/Footer";
import { Link } from "react-router-dom";
import HeadTag from "../Component/HeadTags";
import LazyLoad from "react-lazyload";
const Result = () => {
  const [selectedtab, setSeletedtab] = useState("2025");
  const option = [
    { value: "2025", label: "2025-2026" },
    { value: "2024", label: "2024-2025" },
    { value: "2023", label: "2023-2024" },
  ];

  const handleChange = (event) => {
    setSeletedtab(event.target.value);
  };
  return (
    <>
      <HeadTag title="Hobby Clubs" />
      <Highlights />
      <InnerHaeder />
      <div className="inner_page">
        <div className="container-fluid flwidth">
          <div className="bgimage">
            <h5>
              <Link to="/">
                {" "}
                Home <i className="fas fa-angle-right"></i>{" "}
              </Link>
              <span>
                Academics <i className="fas fa-angle-right"></i> Result{" "}
              </span>
            </h5>
            <h2> Result </h2>
          </div>
          <div className="filter-section">
            <select value={selectedtab} onChange={handleChange}>
              {option.map((option) => {
                return (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                );
              })}
            </select>
          </div>
          <div class="popup-gallery socialWork mt-4">
            {selectedtab === "2025" && (
              <div class="row">
                <div class="col-lg-6 col-md-6">
                  <a
                    href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/new-2026.jpg"
                    data-magnify="gallery"
                    data-src=""
                    data-group="a"
                  >
                    <LazyLoad>
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/new-2026.jpg"
                        class="img-fluid h-auto"
                        alt="Lotus Valley International School, Greater Noida"
                      />
                    </LazyLoad>
                  </a>
                </div>
                <div class="col-lg-6 col-md-6">
                  <a
                    href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/new-2026-1.jpg"
                    data-magnify="gallery"
                    data-src=""
                    data-group="a"
                  >
                    <LazyLoad>
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/new-2026-1.jpg"
                        class="img-fluid h-auto"
                        alt="Lotus Valley International School, Greater Noida"
                      />
                    </LazyLoad>
                  </a>
                </div>
                {/* <div class="col-lg-4 col-md-6">
                  <a
                    href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/new-2026-2.jpg"
                    data-magnify="gallery"
                    data-src=""
                    data-group="a"
                  >
                    <LazyLoad>
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/new-2026-2.jpg"
                        class="img-fluid h-auto"
                        alt="Lotus Valley International School, Greater Noida"
                      />
                    </LazyLoad>
                  </a>
                </div> */}
                <div class="col-lg-6 col-md-6">
                  <a
                    href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/result2025-1.jpeg"
                    data-magnify="gallery"
                    data-src=""
                    data-group="a"
                  >
                    <LazyLoad>
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/result2025-1.jpeg"
                        class="img-fluid h-auto"
                        alt="Lotus Valley International School, Greater Noida"
                      />
                    </LazyLoad>
                  </a>
                </div>
                <div class="col-lg-6 col-md-6">
                  <a
                    href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/result2025-2.jpeg"
                    data-magnify="gallery"
                    data-src=""
                    data-group="a"
                  >
                    <LazyLoad>
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/result2025-2.jpeg"
                        class="img-fluid h-auto"
                        alt="Lotus Valley International School, Greater Noida"
                      />
                    </LazyLoad>
                  </a>
                </div>
              </div>
            )}
            {selectedtab === "2024" && (
              <div class="row">
                <div class="col-lg-4 col-md-6">
                  <a
                    href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/result2024-1.jpg"
                    data-magnify="gallery"
                    data-src=""
                    data-group="a"
                  >
                    <LazyLoad>
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/result2024-1.jpg"
                        class="img-fluid h-auto"
                        alt="Lotus Valley International School, Greater Noida"
                      />
                    </LazyLoad>
                  </a>
                </div>
                <div class="col-lg-4 col-md-6">
                  <a
                    href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/result2024-2.jpg"
                    data-magnify="gallery"
                    data-src=""
                    data-group="a"
                  >
                    <LazyLoad>
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/result2024-2.jpg"
                        class="img-fluid h-auto"
                        alt="Lotus Valley International School, Greater Noida"
                      />
                    </LazyLoad>
                  </a>
                </div>
                <div class="col-lg-4 col-md-6">
                  <a
                    href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/result2024-3.jpg"
                    data-magnify="gallery"
                    data-src=""
                    data-group="a"
                  >
                    <LazyLoad>
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/result2024-3.jpg"
                        class="img-fluid h-auto"
                        alt="Lotus Valley International School, Greater Noida"
                      />
                    </LazyLoad>
                  </a>
                </div>
              </div>
            )}
            {selectedtab === "2023" && (
              <div class="row">
                <div class="col-lg-6 col-md-6">
                  <a
                    href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/result1.jpg"
                    data-magnify="gallery"
                    data-src=""
                    data-group="a"
                  >
                    <LazyLoad>
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/result1.jpg"
                        class="img-fluid h-auto"
                        alt="Lotus Valley International School, Greater Noida"
                      />
                    </LazyLoad>
                  </a>
                </div>
                <div class="col-lg-6 col-md-6">
                  <a
                    href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/result2.jpg"
                    data-magnify="gallery"
                    data-src=""
                    data-group="a"
                  >
                    <LazyLoad>
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/result2.jpg"
                        class="img-fluid h-auto"
                        alt="Lotus Valley International School, Greater Noida"
                      />
                    </LazyLoad>
                  </a>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Result;
